import { render, staticRenderFns } from "./option-selector.vue?vue&type=template&id=48e26f50&scoped=true"
import script from "./option-selector.vue?vue&type=script&lang=js"
export * from "./option-selector.vue?vue&type=script&lang=js"
import style0 from "./option-selector.vue?vue&type=style&index=0&id=48e26f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e26f50",
  null
  
)

export default component.exports